import * as React from 'react'
import { IProgramServiceMembership } from '../../types/membership'
import TableRow from './TableRow'

export interface INewRequestTable {
  items: IProgramServiceMembership[]
  onToggleMembershipModal: () => void
  getMembershipNewRequests: (organizationId: string) => void
  currentOrgId?: string
}

class NewRequestsTable extends React.Component<INewRequestTable> {
  public componentDidMount() {
    if (this.props.currentOrgId) {
      this.props.getMembershipNewRequests(this.props.currentOrgId)
    }
  }

  public render() {
    if (!this.props.currentOrgId) {
      return null
    }

    return (
      <div>
        <div className='flex col-12 h6 font-grey2 px2 border-box'>
          <div className='column col-2'>Basic Info</div>
          <div className='column col-2'>Phone number</div>
          <div className='column col-1'>Mobility</div>
          <div className='column col-2'>Organization</div>
          <div className='column col-1'>Service</div>
          <div className='column col-2'>Requested</div>
          <div className='column col-1'>Status</div>
        </div>
        {this.props.items.map(item => (
          <TableRow key={item.id} item={item} toggleModal={this.props.onToggleMembershipModal} />
        ))}
      </div>
    )
  }
}

export default NewRequestsTable



// WEBPACK FOOTER //
// ./src/components/membership-request/NewRequestsTable.tsx